import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

/**
 * ConflictWarnings — inline, NON-BLOCKING scheduling-conflict display (§1.7/§4.7).
 * Warn, never prevent. Shows reason + optional link to the conflicting item.
 * The user may always proceed.
 *
 * warnings: Array<{ type, message, conflictId? }> from detectConflicts().
 */
export function ConflictWarnings({ warnings = [], onViewConflict }) {
  if (!warnings.length) return null;
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2.5">
      <div className="flex items-center gap-2 mb-1">
        <ExclamationTriangleIcon className="h-4 w-4 text-amber-600" />
        <span className="text-sm font-medium text-amber-800">
          Scheduling conflict{warnings.length > 1 ? 's' : ''} (you can still proceed)
        </span>
      </div>
      <ul className="space-y-1 ml-6">
        {warnings.map((w, i) => (
          <li key={i} className="text-xs text-amber-700 flex items-center gap-2">
            <span>{w.message}</span>
            {w.conflictId && onViewConflict && (
              <button
                type="button"
                onClick={() => onViewConflict(w.conflictId)}
                className="underline hover:text-amber-900"
              >
                View
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ConflictWarnings;
